import React, { useState, useRef, useEffect } from 'react';
import './ListOfParticipants.scss';
import { getAllLecturersInEvent } from '../../services/EventService';
import test7 from '../../assets/test7.png';
import { Config, currentEventId } from '../../config/config';
import { Link, useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';

const ListOfParticipants = (props: any) => {
  const [idEvent, setIdEvent] = useState<string>(currentEventId);
  const [listOfParticipant, setListOfParticipant] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  useEffect(() => {
    getAllLecturersInEvent(idEvent).then((response: AxiosResponse) => {
      setListOfParticipant(response.data.result.lecturers);
    });
  }, []);

  return (
    <div style={{ backgroundColor: props.backgroudColor }} className="list-participants">
      <div className="inner-container">
        <p style={{ color: props.titleColor }} className="title">
          Učesnici
        </p>
        <div className="data-list">
          {listOfParticipant
            ?.slice() // da ne mijenjaš originalni array
            .sort((a: any, b: any) => Number(a.serialNumber) - Number(b.serialNumber))
            .map((el: any, i: number) => {
              return (
                <div
                  key={i}
                  className="single-item"
                  onClick={() => {
                    navigate(`/participants/${el?.id}`);
                  }}>
                  <img className="image" src={`${Config.apiRoot}/files/storage/${el?.photo?.id}`} />

                  <p className="single-item-title">
                    {el.firstName} {el.lastName}
                  </p>

                  <p style={{ color: props.nameColor }} className="name">
                    {el.biography.length > 100 ? el.biography.slice(0, 100) + '...' : el.biography}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default ListOfParticipants;
